module.exports = __webpack_public_path__ + "static/img/04.46c23a7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/guide/ustd/04.png
// module id = cnJP
// module chunks = 1